export default __webpack_public_path__ + "static/media/btn-x.e6ca0f03.svg";